<template>
  <div class="flex h-12 w-full items-center justify-between pl-6">
    <div class="flex items-center gap-2">
      <!-- Warning Icon -->
      <i class="pi pi-exclamation-triangle text-lg"></i>
      <!-- Title -->
      <p class="text-base font-bold">
        {{ $t('manager.conflicts.title') }}
      </p>
    </div>
  </div>
</template>
